var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import styled from '@emotion/styled';
import { Avatar as MuiAvatar } from '@mui/material';
import Text from '../Text';
import colors from '../../themes/colors';
var StyledAvatar = styled(MuiAvatar)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: ", ";\n  height: ", "px;\n  width: ", "px;\n  overflow: hidden;\n"], ["\n  background-color: ", ";\n  height: ", "px;\n  width: ", "px;\n  overflow: hidden;\n"])), function (_a) {
    var bg = _a.bg;
    return bg;
}, function (_a) {
    var size = _a.size;
    return size;
}, function (_a) {
    var size = _a.size;
    return size;
});
var AVATAR_VARIANT_MAP = {
    large: { textVariant: 'tableHeaderOLD', size: 40 },
    small: { textVariant: 'tableHeaderOLD', size: 32 }
};
var makeInitial = function (name) { return name.slice(0, 1).toUpperCase(); };
var createInitials = function (firstName, lastName) {
    var initials = '';
    if (firstName)
        initials += makeInitial(firstName);
    if (lastName)
        initials += makeInitial(lastName);
    return initials;
};
export default function Avatar(props) {
    var _a = props.firstName, firstName = _a === void 0 ? '' : _a, _b = props.lastName, lastName = _b === void 0 ? '' : _b, _c = props.variant, variant = _c === void 0 ? 'large' : _c, _d = props.bg, bg = _d === void 0 ? colors.legacy.rustLight : _d, img = props.img;
    var _e = AVATAR_VARIANT_MAP[variant], textVariant = _e.textVariant, size = _e.size;
    if (img) {
        var imageAlt = "".concat(firstName, " ").concat(lastName, " avatar image");
        return _jsx(StyledAvatar, { src: img, alt: imageAlt, size: size, bg: bg });
    }
    var textLabel;
    if (firstName || lastName)
        textLabel = createInitials(firstName, lastName);
    return (_jsx(StyledAvatar, __assign({ size: size, bg: bg }, { children: textLabel && (_jsx(Text, __assign({ variant: textVariant, color: "offWhite" }, { children: textLabel }))) })));
}
var templateObject_1;
